/**
 * Снимает оболочку { data, success } с ответа бэкенда.
 * @param {unknown} body
 * @returns {unknown}
 */
export function unwrapResponse(body) {
  if (body == null) return body;
  if (typeof body === "object" && "success" in body && "data" in body) {
    return body.data;
  }
  return body;
}
